"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var PhoneIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.98 20.39l-.062.063c-2.674 2.674-8.504 1.18-13.02-3.336C2.38 12.6.888 6.77 3.562 4.097A4.138 4.138 0 013.658 4l1.347-1.346a1.25 1.25 0 011.873.12L9.216 5.8a1.25 1.25 0 01-.196 1.73L6.727 9.412l-.107.107a1.25 1.25 0 00-.164 1.565c1.112 1.712 2.041 2.941 2.787 3.688.746.746 1.975 1.675 3.688 2.787a1.25 1.25 0 001.565-.165l.106-.107 1.883-2.292a1.25 1.25 0 011.73-.196l3.026 2.338a1.25 1.25 0 01.12 1.873l-1.347 1.347a1.266 1.266 0 01-.035.033z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "nonzero",
    d: "M12 3V1c6.075 0 11 4.925 11 11h-2a9 9 0 00-9-9z",
    opacity: ".6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 5a7 7 0 017 7h-2a5 5 0 00-5-5V5z",
    opacity: ".8"
  })));
});
PhoneIcon.category = 'Communication';
var _default = PhoneIcon;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@mineral/icons/build/PhoneIcon.js
// module id = 1127
// module chunks = 0